(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["crown-language-switcher"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('crown-language-form')) return;

    const returnTo = form.elements.namedItem('return_to');
    if (!(returnTo instanceof HTMLInputElement)) return;

    const current = new URL(window.location.href);
    // The selected market and Shopify's cross-domain handoff supply these values.
    current.searchParams.delete('country');
    current.searchParams.delete('shpxid');
    returnTo.value = current.pathname + current.search + current.hash;
  });
  } catch(e) { console.error(e); }
})();

})();
